import type { Locale } from '@xdocs/i18n';

/**
 * STOP-GAP local catalog for the `notifications:` scope (F33), following the
 * exact `web:` precedent (`apps/web/src/i18n/webCatalog.ts` + `useWebT.ts`)
 * — NOT a second i18n runtime (E18/§13.3 ban), just physically scoped here
 * because `packages/i18n/**` is outside this task's ownership boundary.
 * Notification `title`/`body` themselves are pre-rendered + localized
 * SERVER-side at write time (`notificationSchema` doc comment) — this
 * catalog only covers the panel CHROME around them.
 *
 * OPEN ISSUE: fold into `packages/i18n/src/catalogs/{en,ro}/notifications.json`.
 */
const en = {
  'bell.label': 'Notifications',
  'bell.unread': '{count, plural, one {# unread notification} other {# unread notifications}}',
  'panel.title': 'Notifications',
  'panel.filter.all': 'All',
  'panel.filter.unread': 'Unread',
  'panel.markAllRead': 'Mark all read',
  'panel.close': 'Close notifications',
  'empty.title': 'No notifications yet',
  'empty.description': 'Job completions, comments, and credit updates will show up here.',
  'empty.unread.title': 'You’re all caught up',
  'error.title': 'Couldn’t load notifications.',
  'error.retry': 'Retry',
  'item.deletedTarget': 'This is no longer available.',
  'item.markRead': 'Mark as read',
  'item.unreadLabel': 'Unread',
  'loadMore': 'Load more',
  'loadMoreError': 'Couldn’t load more notifications.',
  'credits.label': 'Credits',
  'credits.low': 'Running low on credits',
  'credits.zero': 'Out of credits',
  'item.groupCount': '{count, plural, one {# update} other {# updates}}',
  'item.groupExpand': 'Show details',
  'item.groupCollapse': 'Hide details',
} as const;

const ro: Record<keyof typeof en, string> = {
  'bell.label': 'Notificări',
  'bell.unread': '{count, plural, one {# notificare necitită} few {# notificări necitite} other {# de notificări necitite}}',
  'panel.title': 'Notificări',
  'panel.filter.all': 'Toate',
  'panel.filter.unread': 'Necitite',
  'panel.markAllRead': 'Marchează tot ca citit',
  'panel.close': 'Închide notificările',
  'empty.title': 'Nicio notificare încă',
  'empty.description': 'Finalizările de sarcini, comentariile și actualizările de credite vor apărea aici.',
  'empty.unread.title': 'Ești la zi',
  'error.title': 'Nu am putut încărca notificările.',
  'error.retry': 'Reîncearcă',
  'item.deletedTarget': 'Acest element nu mai este disponibil.',
  'item.markRead': 'Marchează ca citită',
  'item.unreadLabel': 'Necitit',
  'loadMore': 'Încarcă mai multe',
  'loadMoreError': 'Nu am putut încărca mai multe notificări.',
  'credits.label': 'Credite',
  'credits.low': 'Credite pe terminate',
  'credits.zero': 'Fără credite',
  'item.groupCount': '{count, plural, one {# actualizare} few {# actualizări} other {# de actualizări}}',
  'item.groupExpand': 'Arată detalii',
  'item.groupCollapse': 'Ascunde detalii',
};

export const NOTIFICATIONS_CATALOG: Record<Locale, Record<keyof typeof en, string>> = { en, ro };

export type NotificationsCatalogKey = keyof typeof en;
